<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Carga de los meses</span>
          </v-tooltip>
          <h3 class="headline mb-0">Lista de meses</h3>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="nuevoMes">Agregar</v-btn>
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @click:append-outer="searchFilterMonth"
              @change="searchFilterMonth"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
               :loading="loading"
               :headers="headers"
               :items="months"
               rows-per-page-text="Filas por Pág"
               hide-actions
               :pagination.sync="pagination"
             >
               <template slot="items" slot-scope="props">

                 <td>{{ props.item.year}}</td>
                 <td>{{ props.item.name }} </td>

                 <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" >
                          <v-icon color="blue darken-2">description</v-icon>
                        </v-btn>
                        <span>Ver</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" >
                          <v-icon color="green">edit</v-icon>
                        </v-btn>
                        <span>Editar Mes</span>
                    </v-tooltip>

                   <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0">
                          <v-icon color="red">delete</v-icon>
                        </v-btn>
                        <span>Eliminar Mes</span>
                    </v-tooltip>

                 </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

            <div class="text-xs-center">
                <v-layout justify-center>
                  <v-flex xs8>
                    <v-card class="elevation-0">
                      <v-card-text>
                        <v-pagination
                          v-model="page"
                          :length="pages"
                        ></v-pagination>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
            </div>

          </v-card-text>
      </v-card>
    </v-flex>
<!-- Inicio de dialogo de ayuda -->
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Importante...</v-card-title>

        <v-card-text>
          Meses del año para la configuración posterior del costo de conceptos por mes. 
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Salir
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
<!-- Fin de dialogo de ayuda -->
  </v-layout>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: 'months-view',

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        pages () {
            return this.pagination.total
        }
    },

    mounted() {
        this.initComponent(1)
    },

    watch: {
      page(v) {
        if(this.activePagination){
          this.initComponent(v)
        }
        this.activePagination = true
      }
    },

    data () {
        return {
            dialog: false,
            months: [],
            activePagination: false,
            loading: false,
            search: '',
            page: 0,
            pagination: {
                page: 1,
                totalItems: 0,
                rowsPerPage: 10,
                total: 0
            },
            headers: [
                { text: 'AÑO', value: 'year', sortable: false },
                { text: 'MES', value: 'name', sortable: false },
                { text: 'ACCIONES', value: 'acciones', sortable: false }
            ],
        }
    },

    methods: {

        async initComponent (page,search=null) {
            this.loading = true
            const url = search == null ? `/api/months/admin/getMonths?page=${page}` : `/api/months/admin/getMonths?page=${page}&search=${search}`
            await axios.get(url)
                .then(resp => {
                  console.log(resp)
                    this.months = resp.data.data
                    this.page = resp.data.current_page
                    this.pagination = {
                        total: resp.data.last_page,
                        totalItems: resp.data.total,
                        rowsPerPage: resp.data.per_page,
                        page: 1
                    }
                })
                .catch(e => {
                    console.log(e.response,"error");
                })

            this.loading = false
        },

        nuevoMes() {

        },

        searchFilterMonth () {
            this.initComponent(this.page,this.search)
        }

    }

}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/months.vue